import React from 'react';

import { QueryStringContext } from 'contexts/QueryStringContext';
import { convertToArray } from 'Details/utils';
import { TAIL_SPEND } from 'utils/detailsChartDataConverter';
import { CHART_TYPES } from 'Details/DetailsChart/DetailsChart';
import { HeroChartOptions } from './HeroChartOptions';

export class HeroChartOptionsClass extends React.Component {
	handleBreadcumbClick = (_0, index) => {
		let { pmiBreadcrumbs, setQueryStringStateAndPush } = this.props;
		let sliceIndex = index;

		const newBreadcrumbs = pmiBreadcrumbs
			? pmiBreadcrumbs.slice(0, sliceIndex)
			: [];

		setQueryStringStateAndPush({
			pmiBreadcrumbs: newBreadcrumbs,
		});
	};

	handleChange = state => {
		const { pmiBreadcrumbs, setQueryStringStateAndPush } = this.props;

		// if we turn off show tail spend - need to clean tail spend from pmiBreadcrumbs
		if (state.showTailSpend === false) {
			if (pmiBreadcrumbs && pmiBreadcrumbs.includes(TAIL_SPEND)) {
				const newBreadcrumbs = pmiBreadcrumbs.filter(
					item => item !== TAIL_SPEND
				);

				state = { ...state, pmiBreadcrumbs: newBreadcrumbs };
			}
		}

		setQueryStringStateAndPush(state);
	};

	render() {
		const {
			chartType,
			onPngExportClick,
			onXlsExportClick,
			pmiBreadcrumbs,
		} = this.props;

		const breadcurmbsOptions = pmiBreadcrumbs
			? pmiBreadcrumbs.map(breadcrumbValue => ({
					label: breadcrumbValue,
					value: breadcrumbValue,
			  }))
			: [];

		breadcurmbsOptions.unshift({
			label: 'All spend',
			value: 'all',
		});

		return (
			<HeroChartOptions
				{...this.props}
				breadcurmbsOptions={breadcurmbsOptions}
				onBreadcrumbsClick={this.handleBreadcumbClick}
				onChange={this.handleChange}
				chartType={chartType || CHART_TYPES.waterfall}
				onPngExportClick={onPngExportClick}
				onXlsExportClick={onXlsExportClick}
			/>
		);
	}
}

export const HeroChartOptionsContainer = React.memo(props => (
	<QueryStringContext.Consumer>
		{({
			measures,
			showAllCategories,
			showTailSpend,
			showAllSegments,
			waterfallShowAdjusted,
			setQueryStringStateAndPush,
			isTailSpend,
			chartType,
			showNegativeSpend,
			pmiBreadcrumbs,
		}) => {
			isTailSpend = !!isTailSpend && isTailSpend !== 'false';
			showAllSegments = !!showAllSegments && showAllSegments !== 'false';

			// fix for discepancy in the query params
			if (!isTailSpend) {
				showAllSegments = false;
			}

			return (
				<HeroChartOptionsClass
					{...props}
					setQueryStringStateAndPush={setQueryStringStateAndPush}
					measures={measures}
					showAllCategories={
						!!showAllCategories && showAllCategories !== 'false'
					}
					showTailSpend={!!showTailSpend && showTailSpend !== 'false'}
					waterfallShowAdjusted={waterfallShowAdjusted}
					showAllSegments={showAllSegments}
					isTailSpend={isTailSpend}
					chartType={chartType}
					pmiBreadcrumbs={convertToArray(pmiBreadcrumbs)}
					showNegativeSpend={
						!!showNegativeSpend && showNegativeSpend !== 'false'
					}
				/>
			);
		}}
	</QueryStringContext.Consumer>
));

export default HeroChartOptionsContainer;
